import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2051648439 from "../../../../../packages/component/src/components/tab/demo/demo1.js?loadDemo";
import legacyImportDemo_2430948244 from "../../../../../packages/component/src/components/tab/demo/demo2.js?loadDemo";
import legacyImportDemo_2637707637 from "../../../../../packages/component/src/components/tab/demo/demo3.js?loadDemo";
import legacyImportDemo_3181975378 from "../../../../../packages/component/src/components/tab/demo/demo4.js?loadDemo";
import legacyImportDemo_3467532851 from "../../../../../packages/component/src/components/tab/demo/demo5.js?loadDemo";
import legacyImportDemo_556566032 from "../../../../../packages/component/src/components/tab/demo/demo6.js?loadDemo";
import legacyImportDemo_4185870833 from "../../../../../packages/component/src/components/tab/demo/demo7.js?loadDemo";
import legacyImportDemo_1282664414 from "../../../../../packages/component/src/components/tab/demo/demo8.js?loadDemo";
import legacyImportDemo_928981183 from "../../../../../packages/component/src/components/tab/demo/demo9.js?loadDemo";
import legacyImportDemo_2190846279 from "../../../../../packages/component/src/components/tab/demo/demo10.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2051648439,
  legacyImportDemo_2430948244,
  legacyImportDemo_2637707637,
  legacyImportDemo_3181975378,
  legacyImportDemo_3467532851,
  legacyImportDemo_556566032,
  legacyImportDemo_4185870833,
  legacyImportDemo_1282664414,
  legacyImportDemo_928981183,
  legacyImportDemo_2190846279,
  React
};